<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="coin_purchases"
    :submit="submit"
    :status="status"
    :canCancel="true"
    :canSubmit="false"
    :urlSendNotification="url_send_notification"
    :canUpdateDelete="false"
    :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/coin_purchases'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: 'Detalle',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                  ref="user"
                  rules="required"
                  v-slot="{ errors }"
              >
                <div class="label-base pb-1">Usuarios</div>
                <v-text-field
                    :value="data.user_id?.full_name"
                    :error-messages="errors"
                    label="Users"
                    solo
                    hide-details="auto"
                    class="input-base"
                    readonly
                />
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="previous_amount"
                rules=""
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Monto Anterior</div>
                  
                <v-text-field
                   solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  v-model="data.previous_amount"
                  readonly
                  label="Monto Anterior"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="current_amount"
                rules=""
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Monto Actual</div>
                  
                <v-text-field
                   solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  readonly
                  v-model="data.current_amount"
                  label="Monto Actual"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="py-0 px-2">

              <ValidationProvider
                ref="amount_acquired"
                rules=""
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Monto Adquirido</div>
                  
                <v-text-field
                   solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  readonly
                  v-model="data.amount_acquired"
                  label="Monto Adquirido"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="total_in_pesos"
                rules=""
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Total</div>
                  
                <v-text-field
                   solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  readonly
                   :value="totalFormatted"
                  label="Total"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider
                ref="date_approved"
                rules=""
                v-slot="{ errors }"
              >
                <div class="label-base pb-1">Fecha</div>
                  
                <v-text-field
                   solo
                    hide-details="auto"
                    class="input-base"
                  :error-messages="errors"
                  readonly
                  :value="formatDate(data.date_approved)"
                  label="Fecha"
                ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>        
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import {ValidationProvider, ValidationObserver, extend} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';
import moment from "moment";

  extend('numberpositivo', {
    validate: value => {
      return value > 0;
    },
    message: 'El campo debe ser mayor a 0.'
  });

  extend('without_decimals', {
    validate: value => {
      return value % 1 === 0;
    },
    message: 'El valor no debe tener decimales'
  });

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    async created() {
      // await this.$store.dispatch("Users/getListAll", {show_all: 'enable', sorting_column: 'name', sorting_order: 'asc'});
      if (this.$route.params.id) {
        await self.$store
        .dispatch("coin_purchases/show", this.$route.params.id)
        .then((val) => {
          this.data.user_id = val.user_id?.id;
          this.data.previous_amount = val.previous_amount;
          this.data.amount_acquired = val.amount_acquired;
          this.data.current_amount = val.current_amount;
          this.data.total_in_pesos = val.total_in_pesos;
          this.data.commission = val.commission;
          this.data.date_approved = val.date_approved;
        });
      }
    },
    computed: {
      ...mapState({
        users: state => state.Users.list,
      }),
      userItems() {
        if (this.data.user_id && typeof this.data.user_id === 'object') {
          return [this.data.user_id]
        }
        const found = this.users.find(u => u.id === this.data.user_id)
        return found ? [found] : []
      },
      totalFormatted() {
        return Number(this.data.total_in_pesos || 0).toFixed(2)
      }
    },
    data() {
      return {
        storeName: 'Coin_purchases',
        title: "Compra de Coins",
        data: {
          user_id: '',
          previous_amount:'',
          amount_acquired:'',
          current_amount:'',
          total_in_pesos:'',
          commission:'',
          date_approved:'',
          users: [],
        },
        menu_approved_date: false,
      }
    },
    methods: {
      formatDate(created_at) {
        if (!created_at) return null;
        let [date, time] = created_at.split("T");
        const [year, month, day] = date.split("-");
        time = (time.split(".")[0]);
        return `${day}/${month}/${year}`;
      },
    }
  }
</script>
